'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReviewLink = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReviewLink = exports.ReviewLink = function (_React$PureComponent) {
  _inherits(ReviewLink, _React$PureComponent);

  function ReviewLink() {
    _classCallCheck(this, ReviewLink);

    return _possibleConstructorReturn(this, (ReviewLink.__proto__ || Object.getPrototypeOf(ReviewLink)).apply(this, arguments));
  }

  _createClass(ReviewLink, [{
    key: 'handleClick',
    value: function handleClick(event) {
      if (this.props.onClick) {
        this.props.onClick(event, this.props.href);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          href = _props.href,
          className = _props.className,
          children = _props.children,
          ariaLabel = _props.ariaLabel;

      var onClick = function onClick(event) {
        return _this2.handleClick(event);
      };
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'a',
          {
            href: href,
            onClick: onClick,
            className: className,
            'aria-label': ariaLabel
          },
          children
        )
      );
    }
  }]);

  return ReviewLink;
}(_react2.default.PureComponent);

ReviewLink.propTypes = {
  children: _propTypes2.default.node.isRequired,
  href: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  /**
   * Provide this value to give screenreaders longer, more descriptive text to
   * explain the context of the link.
   */
  ariaLabel: _propTypes2.default.string
};

exports.default = ReviewLink;